import { IApprovalStrategyService } from '../../services';
import { ComponentDefinition } from '../../models';

class WtStrategyPicker {
    static $inject = ['approvalStrategyService'];

    approvalStrategy: string;
    approvalStrategies: { guid: string, name: string }[];
    onChange: ({ guid: string }) => void;

    constructor(private approvalStrategyService: IApprovalStrategyService) {
    }

    $onInit() {
        this.approvalStrategyService.getAll()
            .then(data => {
                this.approvalStrategies = data;
            });
    }

    change() {
        if (this.onChange) {
            this.onChange({ guid: this.approvalStrategy });
        }
    }
}

export const wtStrategyPickerDirective: ComponentDefinition = {
    componentId: 'wtStrategyPicker',
    template: require('./strategyPicker.component.html'),
    controller: WtStrategyPicker,
    controllerAs: 'vm',
    bindings: {
        approvalStrategy: '=',
        onChange: '&?',
        isDisabled: '<?',
        name: '@?',
    }
};